(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["bleen-technology-scroll"] && !Shopify.designMode) return;
  try {
    (() => {
    const initTechnologyScroll = (root) => {
      if (!root || root.dataset.technologyReady === 'true') return;
      root.dataset.technologyReady = 'true';

      const tabs = Array.from(root.querySelectorAll('[data-technology-tab]'));
      const panels = Array.from(root.querySelectorAll('[data-technology-panel]'));
      const markers = Array.from(root.querySelectorAll('[data-technology-marker]'));
      const mobile = window.matchMedia('(max-width: 820px)');
      const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      let observer;
      let activeIndex = 0;

      const activate = (index) => {
        const nextIndex = Math.max(0, Math.min(tabs.length - 1, Number(index)));
        activeIndex = nextIndex;
        tabs.forEach((tab, tabIndex) => {
          const active = tabIndex === nextIndex;
          tab.classList.toggle('is-active', active);
          tab.setAttribute('aria-selected', String(active));
          tab.tabIndex = active ? 0 : -1;
        });
        panels.forEach((panel, panelIndex) => panel.classList.toggle('is-active', panelIndex === nextIndex));
        tabs[nextIndex]?.scrollIntoView({ behavior: reducedMotion ? 'auto' : 'smooth', block: 'nearest', inline: 'center' });
      };

      const observe = () => {
        observer?.disconnect();
        const targets = mobile.matches ? panels : markers;
        const rootMargin = mobile.matches ? '-30% 0px -55% 0px' : '-46% 0px -46% 0px';
        observer = new IntersectionObserver((entries) => {
          const visible = entries
            .filter((entry) => entry.isIntersecting)
            .sort((first, second) => second.intersectionRatio - first.intersectionRatio)[0];
          if (!visible) return;
          const value = mobile.matches ? visible.target.dataset.technologyPanel : visible.target.dataset.technologyMarker;
          activate(value);
        }, { rootMargin, threshold: [0, 0.1, 0.25, 0.5] });
        targets.forEach((target) => observer.observe(target));
      };

      tabs.forEach((tab, index) => {
        tab.addEventListener('click', () => {
          activate(index);
          const target = mobile.matches ? panels[index] : markers[index];
          target?.scrollIntoView({ behavior: reducedMotion ? 'auto' : 'smooth', block: mobile.matches ? 'start' : 'center' });
        });
        tab.addEventListener('keydown', (event) => {
          if (!['ArrowDown', 'ArrowRight', 'ArrowUp', 'ArrowLeft', 'Home', 'End'].includes(event.key)) return;
          event.preventDefault();
          let nextIndex = activeIndex;
          if (event.key === 'ArrowDown' || event.key === 'ArrowRight') nextIndex += 1;
          if (event.key === 'ArrowUp' || event.key === 'ArrowLeft') nextIndex -= 1;
          if (event.key === 'Home') nextIndex = 0;
          if (event.key === 'End') nextIndex = tabs.length - 1;
          nextIndex = (nextIndex + tabs.length) % tabs.length;
          tabs[nextIndex]?.focus();
          tabs[nextIndex]?.click();
        });
      });

      mobile.addEventListener('change', observe);
      activate(0);
      observe();
    };

    const initAllTechnologyScrolls = (scope = document) => {
      scope.querySelectorAll('[data-bleen-technology-scroll]').forEach(initTechnologyScroll);
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => initAllTechnologyScrolls());
    } else {
      initAllTechnologyScrolls();
    }

    document.addEventListener('shopify:section:load', (event) => initAllTechnologyScrolls(event.target));
  })();
  } catch(e) { console.error(e); }
})();

})();
